module.exports = __webpack_public_path__ + "static/media/fb.db9fdbcd.png";